<template>
    <div class="popup">
        <div class="popup-content">
            <div class="header">
                <img src="/img/close-btn.svg" class="close-popup-btn" />
            </div>
            <div class="payment-details">
                <div class="title">
                    <span class="heading">
                        <i18n-t keypath="paymentsTransactionsPopup.payments" />
                    </span>
                </div>
                <div class="amount-container">
                    <div class="total-amount">
                        <span class="label">
                            <i18n-t keypath="myOrders.totalAmount" />
                            :
                        </span>
                        <span class="value">
                            <app-format-currency
                                :value="orderPaymentDto?.order_total_amount_including_vat"
                                currency="EUR"
                            />
                        </span>
                    </div>
                    <div class="progress-container">
                        <div
                            class="progress-bar"
                            :style="{
                                width: dot1Position,
                            }"
                        />
                        <div
                            class="overlay-progress-bar"
                            :style="{
                                width: dot2Position,
                            }"
                        />
                    </div>
                    <div class="payment-info">
                        <div class="gap completed">
                            <span class="dot-1"></span>
                            <div class="label-wrapper">
                                <span class="label-1">
                                    <i18n-t keypath="paymentsTransactionsPopup.paidCompleted" />:</span>
                                <span class="app-format-currency">
                                    <app-format-currency
                                        :value="orderPaymentDto?.amount_paid_confirmed"
                                        currency="EUR"
                                    />
                                </span>
                            </div>
                        </div>
                        <div class="gap processing">
                            <span class="dot-2"></span>
                            <div class="label-wrapper">
                                <!-- translation -->
                                <span class="label-2">
                                    <i18n-t keypath="paymentsTransactionsPopup.paidProcessing" />:</span>
                                <span class="app-format-currency">
                                    <app-format-currency
                                        :value="orderPaymentDto.amount_paid_pending"
                                        currency="EUR"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="payment-info-item">
                <div
                    class="payment-item"
                    :style="
                        !isVisible
                            ? 'border-bottom: 1px solid rgba(228, 234, 240, 1)'
                            : ''
                    "
                    v-for="(item, index) in orderPaymentDto?.payments"
                    :key="index"
                >
                    <div class="payment-details-container">
                        <div class="status-chevron">
                            <div>
                                <button
                                    v-if="item.status.id === 1"
                                    class="status-button pending"
                                >
                                    
                                <i18n-t keypath="paymentsTransactionsPopup.pending" />
                                </button>
                                <button
                                    v-if="item.status.id === 2"
                                    class="status-button successful"
                                >
                                    
                                <i18n-t keypath="paymentsTransactionsPopup.successful" />
                                </button>
                                <button
                                    v-if="item.status.id === 3"
                                    class="status-button cancelled"
                                >
                                    
                                <i18n-t keypath="paymentsTransactionsPopup.cancelled" />
                                </button>
                            </div>
                            <div>
                                <img
                                    v-if="isVisible[index]"
                                    width="16"
                                    height="16"
                                    src="/img/chevron-down.svg"
                                    @click="visible(index, null)"
                                />
                                <img
                                    v-else
                                    width="16"
                                    height="16"
                                    src="/img/chevron-down%20(1).svg"
                                    @click="visible(index, item.id)"
                                />
                            </div>
                        </div>
                        <div v-if="item.reference !== null" class="payment-detail-item">
                            <span class="payment-detail-label">
                                <i18n-t keypath="myOrders.paymentReference" />
                                :
                            </span>
                            <span class="payment-detail-value">{{ item.reference }}</span>
                        </div>
                        <div class="payment-detail-item">
                            <span class="payment-detail-label">
                                <i18n-t keypath="paymentsTransactionsPopup.paymentDate" />:</span>
                            <span class="payment-detail-value">
                                {{ formatDate(item.date) }}
                            </span>
                        </div>
                        <div class="payment-detail-item">
                            <span class="payment-detail-label">
                                <i18n-t keypath="paymentsTransactionsPopup.paymentType" />:</span>
                            <span class="payment-detail-value">{{ item.type.name }}</span>
                        </div>
                        <div class="payment-detail-item">
                            <span class="payment-detail-label">
                                <i18n-t keypath="paymentsTransactionsPopup.transactionSum" />:</span>
                            <span class="payment-detail-value">
                                <app-format-currency
                                    :value="item.total_amount_euro"
                                    currency="EUR"
                                />
                            </span>
                        </div>
                        <div class="payment-detail-item">
                            <span class="payment-detail-label">ID:</span>
                            <span class="payment-detail-value">{{ item.id }}</span>
                        </div>
                        <div v-if="item.status.id === 1" class="button-container">
                            <div>
                                <button
                                    class="button-cancel"
                                    @click="cancelPayment(item.id)"
                                >
                                    
                                <i18n-t keypath="paymentsTransactionsPopup.cancel" />
                                </button>
                            </div>
                            <div v-if="item.type.id !== 1" style="margin-left: 15px">
                                <button
                                    class="button-proceed"
                                    @click="proceedPayment(item.id)"
                                >
                                    
                                <i18n-t keypath="paymentsTransactionsPopup.proceed" />
                                </button>
                            </div>
                        </div>
                        <div v-show="isVisible[index]">
                            <div class="dropdown">
                                <div class="dropdown-content">
                                    <div
                                        class="dropdown-item"
                                        v-for="(
                                            item, index
                                        ) in orderVehiclePaymentLinkDto"
                                        :key="index"
                                    >
                                        <div class="img-item">
                                            <img
                                                width="90"
                                                height="59"
                                                :src="item.thumbnail_image.href_small"
                                            />
                                        </div>
                                        <div class="title-item-container">
                                            <div class="title-item-1">
                                                {{ item.vehicle.brand.name }}
                                                {{ item.vehicle.model }}
                                            </div>
                                            <div class="title-item-2">
                                                {{ item.vehicle.powertrain.motorisation }}
                                                {{ item.vehicle.finish }}
                                            </div>
                                            <div class="title-item-3">
                                                € {{ item.payment_amount }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.popup {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.popup-content {
    width: 400px !important;
    height: 100%;
    padding: 20px 0 20px 20px;
    background: rgba(255, 255, 255, 1);
    position: relative;
    overflow-y: auto;
    box-sizing: border-box;
}

.header {
    position: absolute;
    top: 10px;
    right: 20px;
}

.payment-details {
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    padding-right: 20px;
}

.title {
    margin-bottom: 20px;
}

.heading {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    text-align: left;
}

.amount-container {
    margin-bottom: 20px;
}

.total-amount {
    text-align: right;
}

.label {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
}

.progress-container {
    position: relative;
    width: 100% !important;
    height: 4px;
    background-color: #eee;
}

.progress-bar {
    position: absolute;
    max-width: 100%;
    height: 100%;
    background: var(--color-green);
    z-index: 1;
}

.overlay-progress-bar {
    max-width: 100%;
    position: absolute;
    height: 100%;
    background: rgba(249, 198, 17, 1);
    opacity: 0.7;
}

.payment-info {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 5px;
}

.gap {
    display: flex;
    align-items: center;
}

.dot-1,
.dot-2 {
    width: 8px;
    height: 4px;
    border-radius: 20px;
    margin-right: 5px;
}

.dot-1 {
    background: var(--color-green);
}

.dot-2 {
    background: rgba(249, 198, 17, 1);
}

.label-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.label-1,
.label-2 {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(40, 55, 71, 1);
    display: flex;
    align-items: center;
}

.app-format-currency {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0;
    text-align: right;
    white-space: nowrap;
    margin-left: 5px;
}

.payment-info-item {
    display: flex;
    flex-direction: column;
    margin-top: 5%;
    padding-right: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100dvh - 207px);
}

.payment-item {
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
    width: 100% !important;
}

.status-button {
    width: 80px;
    height: 24px;
    padding: 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
}

.successful {
    color: var(--color-green);
    border: 1px solid var(--color-green);
}

.pending {
    color: rgba(229, 182, 0, 1);
    border: 1px solid rgba(229, 182, 0, 1);
}

.cancelled {
    color: rgba(255, 69, 69, 1);
    border: 1px solid rgba(255, 69, 69, 1);
}

.payment-details-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    width: 100% !important;
}

.payment-detail-item {
    width: 100%;
    height: 9px;
    margin-bottom: 10px;
}

.payment-detail-label {
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
}

.payment-detail-value {
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    padding-left: 5px;
}

.label {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
}

.value {
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0;
    text-align: right;
    padding-left: 5px;
}

.close-popup-btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    align-self: flex-end;
    margin-right: 10px;
}

.status-chevron {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.img-item {
    width: 72px;
    height: 59px;
    border-radius: 4px;
}

.title-item-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 227px;
    height: 54px;
    margin-left: 16px;
    margin-bottom: 10px;
}

.title-item-1 {
    font-size: 15px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(40, 55, 71, 1);
}

.title-item-2 {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
}

.title-item-3 {
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(40, 55, 71, 1);
}

.dropdown {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-left: 20px;
}

.dropdown-content {
    top: 100%;
    left: 0;
    width: 100% !important;
    height: 100%;
    background: rgba(228, 234, 240, 0.2);
    transform: translateX(-5%);
    transform-origin: left;
}

.dropdown-item {
    display: flex;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid rgba(228, 234, 240, 1);
    width: 100%;
}

::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #555;
    width: 20px;
}

.button-container {
    display: flex;
    margin-top: 10px;
}

.button-cancel {
    width: 171px;
    height: 40px;
    border-radius: 4px;
    background: rgba(255, 69, 69, 1);
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    border: none;
    transition: transform 0.2s ease;
}

.button-proceed {
    right: 0;
    width: 171px;
    height: 40px;
    border-radius: 4px;
    background: rgba(26, 160, 225, 1);
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    border: none;
    transition: transform 0.2s ease;
}

.button-cancel:hover,
.button-proceed:hover {
    transform: scale(1.05);
}
</style>

<script lang="ts">
import { PaymentsTransactionsPopup } from "@/dashboard/my-orders/new-popup/payments-transactions-popup/payments-transactions-popup";

export default PaymentsTransactionsPopup;
</script>
